import type { LanguageCode } from './languages'
import type { SocialIconName } from '../components/SocialIcon'

type LocalizedLabel = Record<LanguageCode, string>

export type NavigationItem = {
  label: LocalizedLabel
  href: Record<LanguageCode, string>
  children?: NavigationItem[]
}

export type NavigationGroup = {
  label: LocalizedLabel
  items: NavigationItem[]
}

const label = (tr: string, en: string, ru: string): LocalizedLabel => ({ tr, en, ru })

const localized = (slug: string): Record<LanguageCode, string> => ({
  tr: `/tr/${slug}`,
  en: `/en/${slug}`,
  ru: `/ru/${slug}`,
})

const home: NavigationItem = {
  label: label('Anasayfa', 'Home', 'Главная'),
  href: { tr: '/tr/', en: '/en/', ru: '/ru/' },
}

const breakfast: NavigationItem = {
  label: label('Kahvalti', 'Breakfast', 'Завтраки'),
  href: localized('kahvaltilar/'),
}

const hotDrinks: NavigationItem = {
  label: label('Sicak Icecekler', 'Hot Drinks', 'Горячие напитки'),
  href: localized('sicak-icecekler/'),
}

const coldDrinks: NavigationItem = {
  label: label('Soguk Icecekler', 'Cold Drinks', 'Холодные напитки'),
  href: localized('soguk-icecekler/'),
}

const desserts: NavigationItem = {
  label: label('Tatli & Pastane', 'Desserts', 'Десерты'),
  href: localized('tatlilar/'),
}

const about: NavigationItem = {
  label: label('Hakkimizda', 'About', 'О нас'),
  href: localized('hakkimizda/'),
}

const contact: NavigationItem = {
  label: label('Iletisim', 'Contact', 'Контакты'),
  href: localized('iletisim/'),
}

export const mainNavigation: NavigationItem[] = [
  home,
  breakfast,
  hotDrinks,
  coldDrinks,
  desserts,
  about,
  contact,
]

export const mobileNavigationGroups: NavigationGroup[] = [
  {
    label: label('Modi Cafe', 'Modi Cafe', 'Modi Cafe'),
    items: [home, about, contact],
  },
  {
    label: label('Menu', 'Menu', 'Меню'),
    items: [breakfast, hotDrinks, coldDrinks, desserts],
  },
]

export const footerNavigationGroups: NavigationGroup[] = [
  {
    label: label('Modi Cafe', 'Modi Cafe', 'Modi Cafe'),
    items: [home, about, contact],
  },
  {
    label: label('Menu', 'Menu', 'Меню'),
    items: [breakfast, hotDrinks, coldDrinks, desserts],
  },
]

export const corporateLegacy = about

export const socialLinks = [
  {
    label: 'Instagram',
    href: '#',
    icon: 'instagram',
  },
  {
    label: 'Facebook',
    href: '#',
    icon: 'facebook',
  },
] satisfies Array<{ label: string; href: string; icon: SocialIconName }>

export const siteContact = {
  phoneDisplay: 'Telefon',
  phoneHref: 'tel:+902260000000',
  whatsappDisplay: 'WhatsApp',
  whatsappHref: 'https://wa.me/902260000000',
  email: 'info@modicafe.com',
}

export const legacyLogo = {
  header: '/modi-cafe-logo.png',
  alt: 'Modi Cafe',
}
